import jQuery from 'jquery';
let $ = jQuery;

import "LIBS/jquery.showhtml.js";
import "LIBS/jquery.validate.js";
import "LIBS/jquery.validate.unobtrusive.js";
import accessibilityUtil from 'HSNDIR/AccessibilityUtility.js';

//**
//  *class HSN.OffCanvas
//  *Encapsulates the functionality of a Off Canvas dialog that contains product information.
//**

HSN.OffCanvas = (function () {
    OffCanvas.prototype.settings = {};
    OffCanvas.prototype.elementToFocusOnClose = null;

    OffCanvas.EVENT = {
        OPEN: 'HSN.OffCanvas.EVENT.OPEN',
        CLOSE: 'HSN.OffCanvas.EVENT.CLOSE',
    }

    OffCanvas.SOURCE_DIRECTION = {
        LEFT: 'left',
        RIGHT: 'right',
        TOP: 'top',
        BOTTOM: 'bottom'
    }
        
    function OffCanvas(settings) {
        var __scope = this;
        __scope.settings = settings;
        var className = settings.className;
        var sourceDirection = settings.sourceDirection;

        $(window).on('keydown', function (event) {
            var keyCode = event.keyCode || event.which;
            if (keyCode != 27) {
                return;
            }
            __scope.Hide();
        });

        $(document).on('click', '#modal-mask-oc', function () {
            __scope.Hide();
        });

        this.Root = className ? $('<div class="off-canvas ' + className + ' ' + sourceDirection + '"></div>') : $('<div class="off-canvas"></div>');
        this.Root.hide();

        var ariaFirst = '<div role="presentation" aria-modal="true" aria-label="Dialog opened" tabindex="0" class="visuallyhidden">Dialog opened</div>';
        this.Root.append(ariaFirst);

        this.Close = $('<a href="#" id="close" tabindex="0" class="close" aria-label="close dialog" style="display:none"></a>');
        this.Close.on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();

            if(__scope.elementToFocusOnClose) {
                __scope.elementToFocusOnClose.focus();
            }
            __scope.Hide();
        });
        this.Close.on('keyup', function (e) {
            e.preventDefault();
            e.stopPropagation();

            var keys = accessibilityUtil.GetKeys();
            var key = e.keyCode || e.which;
            if(key === keys.enter) {
                if(__scope.elementToFocusOnClose) {
                    __scope.elementToFocusOnClose.focus();
                }
                __scope.Hide();
            }
        });

        this.Root.append(this.Close);

        this.Content = $('<div class="off-canvas-content" tabindex="0"></div>');
        this.Root.append(this.Content);

        this._initialize();
    }

    OffCanvas.prototype._initialize = function () {
    };

    // This private method must be implemented by all HSN.OffCanvas subclasses.
    OffCanvas.prototype._show = function () {
        throw "_show() is not implemented in " + this.constructor.name;
    };
    OffCanvas.prototype.Root = null;
    OffCanvas.prototype.Banner = null;

    //**
    //    * HSN.OffCanvas#Content -> jQuery
    //    *
    //    * [[HSN.OffCanvas#Content]] provides access to the jQuery-wrapped HTML element that contains the content for the Off Canvas.
    //**
    OffCanvas.prototype.Content = null;

    //**
    //    * HSN.OffCanvas#Root -> jQuery
    //    *
    //    * [[HSN.OffCanvas#Content]] provides access to the jQuery-wrapped HTML element that is the root of the Off Canvas.
    //**
    OffCanvas.prototype.Root = null;

    //**
    //    * HSN.OffCanvas#Hide() -> void
    //    *
    //    * Hides the Off Canvas.
    //**
    OffCanvas.prototype.Hide = function () {
        var __scope = this;

        if (!__scope.Root.is(':visible')) {
            return;
        }

        if ('_hide' in __scope) {
            __scope._hide();
        }

        $('#modal-mask-oc').remove();

        this.Content.showHtml(
            '',
            0,
            function () {
                __scope.Root.hide("slide");
            },
            function () {
            }
        );

        HSN.Instance().Events.Trigger(HSN.OffCanvas.EVENT.CLOSE);
    };

    //**
    //    * HSN.OffCanvas#Show() -> void
    //    *
    //    * Shows the Off Canvas.
    //**
    OffCanvas.prototype.Show = function () {
        var classToAttach = 'body';
        if (this.settings.maskPage && !$('#modal-mask-oc').is(':visible')) {
            $('<div></div>').prependTo(classToAttach).attr('id', 'modal-mask-oc');
            this.PositionMask();
            $('#modal-mask-oc').show();
        }
        this.Root.addClass('loading');
        this.AddLoadingSpinner();
        this.Content.empty();
        this.Root.show();
        this._show.apply(this, arguments);

        HSN.Instance().Events.Trigger(HSN.OffCanvas.EVENT.OPEN);
    };

    OffCanvas.prototype.DisplayContent = function (htmlData) {
        var scope = this;

        this.Content.showHtml(htmlData,
            0,
            function () {
                scope.RemoveLoadingSpinner();
                scope.Root.removeClass('loading');
                scope.Content.show("slide", { direction: scope.sourceDirection }, 2000);
                scope.Root.find('#close').show();
            },
            function () {
            }
        );
    };

    OffCanvas.prototype.PositionMask = function () {
        $('#modal-mask-oc').css('height', $(document).height());
        $('#modal-mask-oc').css('width', $(document).width());
    };

    OffCanvas.prototype.HandleError = function (errorMessage) {
        var scope = this;
        var error = errorMessage || 'Unfortunately there was an error attempting to load the content, please try again.';
        alert(error);
        scope.Hide();
    };

    OffCanvas.prototype.Refresh = function () {
        this.Show.apply(this, arguments);
    };
    OffCanvas.prototype.AddLoadingSpinner = function () {
        if (!this.Root.find('#loading').length > 0) {
            this.Root.append('<div id="loading" class="spinner-positioner-relative"><div class="spinner-container small"><div id="floatingCircles48"><div class="f_circle48" id="frotate48_01"></div><div class="f_circle48" id="frotate48_02"></div><div class="f_circle48" id="frotate48_03"></div><div class="f_circle48" id="frotate48_04"></div><div class="f_circle48" id="frotate48_05"></div><div class="f_circle48" id="frotate48_06"></div><div class="f_circle48" id="frotate48_07"></div><div class="f_circle48" id="frotate48_08"></div></div></div></div></div>');
        }
    };
    OffCanvas.prototype.RemoveLoadingSpinner = function () {
        this.Root.find('#loading').remove();
        this.Root.removeClass('loading');
    }

    OffCanvas.prototype.SetElementToFocusOnClose = function (element) {
        this.elementToFocusOnClose = element;
    };

    //Use to set focus inside modal for ADA
    OffCanvas.prototype.SetFocus = function (element) {
        element.focus();
    };

    return OffCanvas;
})();



// WEBPACK FOOTER //
// ./assets/js/HSN/OffCanvas.js